import { render, staticRenderFns } from "./OpCalendarItem.vue?vue&type=template&id=53474ee1&scoped=true&"
import script from "./OpCalendarItem.vue?vue&type=script&lang=js&"
export * from "./OpCalendarItem.vue?vue&type=script&lang=js&"
import style0 from "./OpCalendarItem.vue?vue&type=style&index=0&id=53474ee1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53474ee1",
  null
  
)

export default component.exports